module.exports = __webpack_public_path__ + "f40771151d87c830c500375d291b56f4.png";